import { Dispatch } from 'react';
import { saveOrder as saveOrderApi } from '../../api/order';
import { getAttendeeDeliveryMethodsPayloadForPlacingOrder } from '../../selectors/order';
import { getOrderId } from '../../selectors/order/typedOrderSelectors';
import { getSurvey } from '../../selectors/survey';
import { CheckoutState } from '../../state';
import { getFormDataForTaxExemption } from './getFormDataForTaxExemption';

export const saveOrderWithTaxExemption =
    () =>
    (_dispatch: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        const state = getState();
        const orderId = getOrderId(state);
        const deliveryMethods =
            getAttendeeDeliveryMethodsPayloadForPlacingOrder(state);
        const formData = getFormDataForTaxExemption(state);
        const {
            prePaymentSurveySettings: { getAnswersPayloadForBackend },
        } = getSurvey(state);
        const surveyAnswersPayload = getAnswersPayloadForBackend(formData);

        return saveOrderApi({
            orderId,
            deliveryMethods,
            surveyAnswersPayload,
        });
    };
